import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import memoizeOne from 'memoize-one';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import {
  orderByNewlyReleased,
  orderByRecentlyPlayed
} from 'containers/GameSlotsPage';
import GameIcon from 'components/GameIcon';
import LoadingIndicator from 'components/LoadingIndicator';
import {
  GET_GAMES_QUERY,
  SUBSCRIPTION_GAME_UDPATES
} from 'utils/graphql/gamingQueries';
import HomepageButton from '../HomepageButton';
import './TrendingNow.css';

class TrendingNow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      games: []
    };

    this.orderByRecentlyPlayedMemo = memoizeOne(orderByRecentlyPlayed);
    this.orderByNewlyReleasedMemo = memoizeOne(orderByNewlyReleased);
  }

  render() {
    if (this.props?.data?.loading) {
      return <LoadingIndicator />;
    }
    const gamesMemo = this.orderByRecentlyPlayedMemo(
      this.props?.data?.games?.games
    )?.slice(0, 3);

    if (gamesMemo?.length < 3) {
      gamesMemo.push(
        ...this.orderByNewlyReleasedMemo(this.props?.data?.games?.games)?.slice(
          0,
          3 - (gamesMemo?.length ?? 0)
        )
      );
    }

    const isNotEmpty = gamesMemo?.length > 0;

    return (
      <div className="trending-now-wrapper">
        <div className="trending-now-title">Recently Released</div>
        <div className="trending-now-games">
          {isNotEmpty &&
            gamesMemo.map(game => (
              <div
                key={`trending-now-games-${game.id}`}
                className="trending-now-game"
              >
                <div className="trending-now-game-sub-title">Game</div>
                <div className="trending-now-game-title">
                  {game.displayName}
                </div>
                <div className="trending-now-game-icon">
                  <Link
                    className="trending-now-game-play"
                    to={`/game/${game.slug}`}
                  >
                    <HomepageButton title="Play" />
                  </Link>
                  <GameIcon
                    game={game}
                    badge={game.badge}
                    alt={game.displayName}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default compose(
  graphql(GET_GAMES_QUERY, {
    options: props => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: ({ ownProps, data }) => ({
      data,
      subscribeToGameUpdates: () => {
        return data.subscribeToMore({
          document: SUBSCRIPTION_GAME_UDPATES,
          updateQuery: (prev, { subscriptionData }) => {
            if (!subscriptionData) {
              return null;
            }

            let result = cloneDeep(prev);
            const { game, removeGameId } = subscriptionData.data;
            const gameList = result.games.games;

            if (game) {
              const gameIndex = gameList.findIndex(
                oldGame => game.id === oldGame.id
              );
              gameList.splice(gameIndex, 1, game);
            }

            if (removeGameId) {
              const gameIndex = gameList.findIndex(
                game => removeGameId.toString() === game.id
              );
              gameList.splice(gameIndex, 1);
            }

            return result;
          }
        });
      }
    })
  })
)(TrendingNow);
